'use client';

import Link from 'next/link';

// material-ui
import { useTheme, styled } from '@mui/material/styles';
import { Button, Card, CardContent, CardMedia, Grid, Typography } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';

// assets
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

const imageBackground = '/assets/images/maintenance/img-500-error.svg';
const imageDarkBackground = '/assets/images/maintenance/img-500-error.svg';

// styles
const CardMediaWrapper = styled('div')({
  maxWidth: 720,
  margin: '0 auto',
  position: 'relative'
});

const ErrorWrapper = styled('div')({
  maxWidth: 350,
  margin: '0 auto',
  textAlign: 'center'
});

const ErrorCard = styled(Card)({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

// ==============================|| ERROR PAGE ||============================== //

type ErrorProps = {
  errorMessage?: string;
};

const Error = ({ errorMessage }: ErrorProps) => {
  const theme = useTheme();

  return (
    <ErrorCard>
      <CardContent>
        <Grid container justifyContent="center" spacing={gridSpacing}>
          <Grid item xs={12}>
            <CardMediaWrapper
              style={{
                maxWidth: 500,
                maxHeight: 560
              }}
            >
              <CardMedia
                component="img"
                image={theme.palette.mode === 'dark' ? imageDarkBackground : imageBackground}
                title="Slider5 image"
              />
            </CardMediaWrapper>
          </Grid>
          <Grid item xs={12}>
            <ErrorWrapper>
              <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                  <Typography variant="h4" component="div">
                    Internal Server Error
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6">{`We're fixing an issue on our server. Please try refreshing the page shortly. Thank you for your patience.`}</Typography>
                </Grid>

                {errorMessage && (
                  <Grid item xs={12}>
                    <Typography color="red" variant="h6">
                      Error Details: {errorMessage}
                    </Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <AnimateButton>
                    <Button variant="contained" size="large" component={Link} href={DASHBOARD_PATH}>
                      <HomeTwoToneIcon sx={{ fontSize: '1.3rem', mr: 0.75 }} /> Home
                    </Button>
                  </AnimateButton>
                </Grid>
              </Grid>
            </ErrorWrapper>
          </Grid>
        </Grid>
      </CardContent>
    </ErrorCard>
  );
};

export default Error;
